module.exports = __webpack_public_path__ + "558dc23eda6ae0b30e8ad044d062513e.glb";